(function($) {
	$(function() {
		// $('.hp-band-slider').owlCarousel({
		// 	rtl: rtl,
		// 	items: 1,
		// 	loop: true,
		// 	autoplay: true,
		// 	autoplayTimeout: 5000,
		// 	autoplayHoverPause: true,
		// 	dots: false,
		// 	nav: false,
		// });
		var mainSliderCarousel = $(".main-slider").owlCarousel({
			rtl: rtl,
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			lazyLoad: true
			// animateOut: 'fadeOutRight',
			// animateIn: 'fadeInRight',
		});
		pauseFirstSlide();

		function pauseFirstSlide() {
			mainSliderCarousel.trigger('stop.owl.autoplay');
			setTimeout(function() {
				mainSliderCarousel.trigger('play.owl.autoplay');
			}, 9000);
		}

		mainSliderCarousel.on('changed.owl.carousel', function(e) {
			
			if (e.page.index === 0) {
				pauseFirstSlide();
			}

		});

		$('.platform-block .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			lazyLoad: true,
			dots: false,
			nav: false
		});
	});
	$window.on('load', function() {
		var slidersComplete = [];
		if ($('.home-page').length) {
			//Trading ideas
			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/ti',
				dataType: 'json',
				data: {
					action: 'get',
					lang: globalLang,
					limit: 20
				},
				complete: function() {
					slidersComplete[0] = true;
				},
				success: function(res) {

					var config = {
							'EUR/USD': 111,
							'USD/JPY': 114,
							'GBP/USD': 113,
							'Gold': 185,
							'DUK+': 220
						},
					    ideasList = $('#trading-ideas-list'),
					    bigItemTemplate = ideasList.children(),
					//[111, 114, 113, 185], //for right odering
						//tradIdeasSliders = $('.trading-ideas-slider'),
					    //bigItemTemplate = tradIdeasSliders.eq(0).children(),
					    bigItem,
					    item;
					$.each(config, function(name, id) {
						if (res[id]) {
							bigItem = bigItemTemplate.clone();
							bigItem.find('.curr-pair').addClass(name).text(name).attr('href', res[id][0].url);
							var slider = bigItem.find('.trading-ideas-slider'),
								sliderItemTemplate = slider.children();
							$.each(res[id], function(index, newsBlock) {
								item = sliderItemTemplate.clone();
								item.find('.time').text(newsBlock.date);
								item.find('.title').attr('href', newsBlock.url).text(newsBlock.title);
								item.find('.descr').attr('href', newsBlock.url).text(newsBlock.text);
								slider.append(item);
							});
							sliderItemTemplate.remove();
							ideasList.append(bigItem);
						}
					});
					bigItemTemplate.remove();
					$('.trading-ideas-slider').owlCarousel({
						items: 1,
						rtl: rtl,
						dots: false,
						onInitialized: checkIfPossibleToDrag
					});
					arrowsHandler($('.trading-ideas'));
				},
				error: function(err) {
					console.log('tradingidea api error', err);
				}
			});
			//Market research slider
			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/marketresearch',
				dataType: 'json',
				data: {
					action: 'get',
					lang: globalLang
				},
				success: function(res) {
					var mrProdSlider = $('#mr-product-slider'),
					    mrProdGroup = $('.mr-products'),
					    itemTemplate = mrProdSlider.children(),
						item;
						
					if (res.length) {
						$.each(res, function(key, val) {
							var urlPart = itemTemplate.data('src');
							item = itemTemplate.clone().attr({
								'href': val.url,
								'data-src': urlPart + val.abbr + '.jpg',
								'data-src-retina': urlPart + val.abbr + '@2x.jpg'
							}).addClass('mr-' + val.abbr);
							//item.find('.time').text(val.date).next().html(val.category);
							item.find('h2').html(val.category);
							mrProdSlider.append(item);
						});
						itemTemplate.remove();

						var responsiveSett = {
							0 : {
								items: 1
							}
						};
						var resLength = res.length;
						if (resLength >= 4) {
							responsiveSett['501'] = {
								items: 2
							};
							responsiveSett[cssBreakPoints.sm] = {
								items: 3
							};
							responsiveSett[cssBreakPoints.lg] = {
								items: 4
							};
						} else {
							switch (resLength) {
								case 2:
									responsiveSett['501'] = {
										items: 2
									};
									break;
								case 3:
									responsiveSett[cssBreakPoints.sm] = {
										items: 3
									};
									break;
							}
						}
						mrProdSlider.owlCarousel({
							margin: 30,
							rtl: rtl,
							responsive: responsiveSett,
							onInitialized: checkIfPossibleToDrag,
							dots: false,
							lazyLoad: true
						});
						arrowsHandler(mrProdGroup);
					} else {
						mrProdGroup.addClass('hidden');
					}
				},
				error: function(err) {
					console.log('marketresearch api error', err);
				}
			});
			//Videos slider
			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/video',
				dataType: 'json',
				data: {
					action: 'startpage',
					lang: globalLang,
					limit: 21
				},
				success: function(res) {
					var dcTv = $('#dc-tv'),
					    dcTvNavTabs = dcTv.find('.nav-tabs'),
					    tabTemplate = dcTvNavTabs.children(),
					    dcTvTabContent = dcTv.find('.tab-content'),
					    tabPaneTemlate = dcTvTabContent.children(),
					    tab,
					    tabPane,
					    itemThumb,
						itemText,
						active = true;//To activate first tab
					$.each(res.video, function(index, val) {
						if (val.length) {
							//Tabs titles
							tab = (active) ? tabTemplate.clone().addClass('active') : tabTemplate.clone();
							tab.children().attr('href', '#tab-' + res.title[index].id).html(res.title[index].name);
							dcTvNavTabs.append(tab);
							//Tabs content
							tabPane = (active) ? tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id).addClass('active') : tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id);
							var thumbContainer = tabPane.find('.thumb-slider'),
							    thumbTemlate = thumbContainer.children(),
							    textContainer = tabPane.find('.text-slider'),
							    textTempate = textContainer.children();
							$.each(res.video[index], function(index, videoInfo) {
								itemThumb = thumbTemlate.clone();
								itemText = textTempate.clone();
								//itemThumb.children().attr('src', videoInfo.sthumb.replace('|148', '|270'));
								itemThumb.children().attr({
									'data-src': videoInfo.sthumb.replace('|148', '|449')
								});//For lazy load
								itemText.find('.date').text(videoInfo.date);
								itemText.find('.title').text(videoInfo.title).add(itemThumb).attr('href', 'https://www.dukascopy.com/tv/' + videoInfo.lang + '/view/' + videoInfo.id + '#0');
								thumbContainer.append(itemThumb);
								textContainer.append(itemText);
							});
							dcTvTabContent.append(tabPane);
							thumbTemlate.remove();
							textTempate.remove();
							active = false;
						}
					});
					tabTemplate.remove();
					tabPaneTemlate.remove();
					slidersComplete[2] = true;
					dcTv.find('.open-video').on('click', function(e) {
						e.preventDefault();
						window.open($(this).attr('href'),
							        'videoPlay',
							        'width=700,height=750,scrollbars=yes,resizable=yes');
					});
					var responsivSett = {
						0 : {
							items: 1
						}
					};
					responsivSett[cssBreakPoints.xs] = {
						items: 2
					};
					responsivSett[cssBreakPoints.sm] = {
						items: 3
					};
					$('.dc-tv-slider').owlCarousel({
						margin: 30,
						rtl: rtl,
						responsive : responsivSett,
						onInitialized: checkIfPossibleToDrag,
						lazyLoad: true,
						dots: false
					});
					arrowsHandler($('.dc-tv'));

					//To position arrows on .dc-tv-slider in correct way it was needed to separate img and description on different carousels
					$('.dc-tv .tab-pane').each(function() {
						var tabPane = $(this);
						tabPane.find('.dc-tv-slider').on('dragged.owl.carousel', function(event) {
							tabPane.find('.dc-tv-slider').trigger('to.owl.carousel', [event.item.index,300,true]);
						});
					});
				},
				error: function(err) {
					console.log('video api error', err);
				}
			});
			// var sliderBlocks = $('.trading-ideas, .mr-products, .dc-tv'),
			//     arrowsHandlerTimer = setInterval(function() { //To be sure, all sliders DOMs are ready
			// 		for (var i = 0; i < sliderBlocks.length - 1; i++) {
			// 			if (!slidersComplete[i]) {
			// 				return;
			// 			}
			// 		}
			// 		arrowsHandler();
			// 	}, 100);
			function arrowsHandler(sliderBlock) {
				//clearInterval(arrowsHandlerTimer);
				//Nav arrows and carousels sliding
				var NextBtns = sliderBlock.find('.owl-next'),
				    PrevBtns = sliderBlock.find('.owl-prev');
				NextBtns.on('click', function() {
					$(this).parents('.owl-carousel-group').find('.owl-carousel').trigger('next.owl.carousel');
				});
				PrevBtns.on('click', function() {
					$(this).parents('.owl-carousel-group').find('.owl-carousel').trigger('prev.owl.carousel');
				});
			}
		}
	});
	function checkIfPossibleToDrag(event) { //If not enoght items - don't show arrows
		if (event.item.count <= event.page.size) {
			$(event.target).parents('.navigation-check').addClass('nothing-to-drag');
			setTimeout(function(){$(event.target).trigger('refresh.owl.carousel')}, 1000);
		}
	}
})(jQuery)